import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { RegisterForm } from '../../components/auth'
import { useAuthStore } from '../../store'

/**
 * Pagina di registrazione
 */
export default function Register() {
  const navigate = useNavigate()
  const { utente } = useAuthStore()

  // Redirect se già loggato
  useEffect(() => {
    if (utente) {
      navigate('/', { replace: true })
    }
  }, [utente, navigate])

  const handleSuccess = () => {
    navigate('/profilo', { replace: true })
  }

  return (
    <div className="container mx-auto px-4 py-12">
      <div className="max-w-md mx-auto">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="font-display text-4xl text-white mb-2">Registrati</h1>
          <p className="text-gray-400">
            Crea un account per salvare i tuoi locali preferiti e segnalarne di nuovi
          </p>
        </div>

        {/* Card form */}
        <div className="bg-night-light border border-gray-800 rounded-xl p-8">
          <RegisterForm onSuccess={handleSuccess} />
        </div>
      </div>
    </div>
  )
}
